interface DetenteurPosteListItem {
  agentRenouvele?: string | null;
}

export function formatDetenteurPoste(demande: DetenteurPosteListItem): string {
  return demande?.agentRenouvele?.trim() ?? '';
}
